import React from 'react'
import { TermsAndConditionsMetaProps } from '../data/types'
import { Button, Modal } from './ui'

type Props = {
    isOpen: boolean
    onAgree: () => void
    onDisagree: () => void
    meta: TermsAndConditionsMetaProps
    isLoading?: boolean
}

export const TermsAndConditionsModal = (props: Props) => {
    const { isOpen, onAgree, onDisagree, meta, isLoading = false } = props

    const footer = (
        <div className="flex justify-end gap-3">
            <Button
                onClick={onDisagree}
                disabled={isLoading}
                color='neutral'
                variant='outline'
            >
                {meta.disagreeButton}
            </Button>
            <Button
                onClick={onAgree}
                disabled={isLoading}
                color='primary'
            >
                {isLoading ? 'Processing...' : meta.agreeButton}
            </Button>
        </div>
    )

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => {}} // Prevent closing by clicking outside
            title={meta.title}
            footer={footer}
            maxWidth="2xl"
            showCloseButton={false} // Prevent closing via X button
        >
            <div className="px-6 py-6 max-h-[60vh] overflow-y-auto">
                <div className="prose dark:prose-invert max-w-none">
                    {meta.content.split('\n\n').map((paragraph, index) => {
                        const parts = paragraph.match(/^(\*\*[^*]+\*\*):?\s*(.*)$/)

                        // Extract the bold title and content
                        if (parts) {
                            const [, title, content] = parts
                            const [, titleText] = title.split('**')
                            return (
                                <div key={index} className="mb-4">
                                    <p className="font-semibold text-gray-900 dark:text-gray-100 mb-1">
                                        <strong>{titleText.replace(/\*\*/g, '')}</strong>
                                    </p>
                                    <p className="text-gray-700 dark:text-gray-300 ms-6">
                                        {content.trim().split('\\n').map((line, i) => (
                                            <React.Fragment key={i}>
                                                {line}
                                                {i < content.trim().split('\\n').length - 1 && <br />}
                                            </React.Fragment>
                                        ))}
                                    </p>
                                </div>
                            )
                        }

                        // Regular paragraph
                        return (
                            <p key={index} className="text-gray-700 dark:text-gray-300 mb-4">
                                {paragraph}
                            </p>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}
